import classNames from 'classnames'
import * as React from 'react'

interface ManualGridProps extends React.HTMLProps<HTMLDivElement> {
  numberOfLines?: number
  visibleLeftAxes?: number
  estimateAreaWidth?: number
  rightOffset?: number
}

function ManualGridComponent(
  {
    numberOfLines = 5,
    visibleLeftAxes = 0,
    rightOffset = 32,
    estimateAreaWidth,
    children,
    ...props
  }: React.PropsWithChildren<ManualGridProps>,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const lines = Array.from({ length: numberOfLines })

  return (
    <div ref={ref} {...props} className={classNames('relative flex justify-end', { 'w-full': visibleLeftAxes === 0 })}>
      <div
        style={{ right: rightOffset }}
        className={classNames('absolute flex h-full flex-col justify-between', {
          'left-0': visibleLeftAxes === 0,
          'left-14': visibleLeftAxes === 1,
          'left-28': visibleLeftAxes === 2,
        })}
      >
        {lines.map((_, index) => (
          <div key={index} className="border-t border-dashed border-secondary" />
        ))}
        {!!estimateAreaWidth && (
          <div
            className="pointer-events-none absolute bottom-0 right-0 z-10 h-full bg-stripes text-gray-50 mix-blend-multiply dark:text-gray-100"
            style={{ width: estimateAreaWidth }}
          />
        )}
      </div>

      {children}
    </div>
  )
}

export const ManualGrid = React.forwardRef(ManualGridComponent)
